import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import HeaderHomeVisit from "../Components/Home Visit/headerHomeVisit";
import HomeVisitList from "../Components/Home Visit/listHomeVisit";
import ViewHomeVisit from "../Components/Home Visit/viewHomeVisit";

const HomeVisitRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
//   const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
//   const hasPermission = canAdd || canEdit;
  return (
    <Routes>
      <Route path="/home_visit" element={canAdd ? <HeaderHomeVisit /> : <Navigate to="/dashboard" replace />}></Route>
      <Route path="/home_visit_list" element={canAdd ? <HomeVisitList /> : <Navigate to="/dashboard" replace />}></Route>
      <Route path="/home_visit/view/:id" element={canAdd ? <ViewHomeVisit /> : <Navigate to="/dashboard" replace />}></Route>
    </Routes>
  );
};

export default HomeVisitRoutes;
